import { create } from 'zustand'
interface CommonStore {
  collapsedSidebar: boolean
  setCollapsedSidebar: (role: boolean) => void
}

const initialValue = {
  collapsedSidebar: false,
}
export const useCommonStore = create<CommonStore>((set) => ({
  ...initialValue,
  setCollapsedSidebar: (val) => set(() => ({ collapsedSidebar: val })),
}))
